module.exports = __webpack_public_path__ + "img/program.c7ec8ad4.png";